// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__OiN1y","emails":"CreateEditClinics_emails__3Y9sE","emailTagLabel":"CreateEditClinics_emailTagLabel__Jf9gC"};